import { writable } from "svelte/store";

export const selectCompanionSceneVisibleStore = writable(false);
